module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/moments-of-pleasure.274baa3b.jpg";